import ProfileImageContainer from "@/components/home/ProfileImageContainer";
import UseGetApplicatorGroups from "@/hooks/FamilyProfile/useGetApplicatorGroups";
import { pathes } from "@/routing/pathes";
import { icons } from "@/shahrzad-assets/shared-asstes/icons";
import { colors } from "@/shahrzad-assets/shared-constants/colors";
import { dimens } from "@/shahrzad-assets/shared-constants/dimens";
import ContentLayout from "@/shahrzad-assets/shared_components/ContentLayout";
import CustomButton from "@/shahrzad-assets/shared_components/CustomButton";
import CustomLoading from "@/shahrzad-assets/shared_components/CustomLoading";
import PageTitle from "@/shahrzad-assets/shared_components/PageTitle";
import { Col, Divider, Row } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";

const MyGroups = () => {
    const { fetchApplicatorGroups, applicatorGroupsLoading, groups } = UseGetApplicatorGroups()
    
    const navigate = useNavigate();
    const navigateToGroup = (id: number, groupTypeId: number, title: string) => navigate(pathes.GROUP,{ state: { groupId: id, groupTypeId, title: title} });
    
    useEffect(() => {
        fetchApplicatorGroups()
    },[])

    return ( 
        <>
            <PageTitle title="گروه های من" />
            <ContentLayout>
                <Groups>
                    {
                        applicatorGroupsLoading ? (
                            <CustomLoading/>
                        ) : (
                            groups?.map((data,i) => (
                                <GroupItem key={i}>
                                    <Content onClick={() => navigateToGroup(data?.id, data?.groupTypeId, data?.title)}>
                                        <Col>
                                            <ProfileImageContainer>
                                                {data?.title?.[0]}
                                            </ProfileImageContainer>
                                        </Col>
                                        <GroupInfo>
                                          <h4>{data?.title}</h4>
                                        </GroupInfo>
                                    </Content>
                                    <Divider/>
                                </GroupItem>
                            ))
                        )
                    }
                </Groups>
                <NewGroupButton>
                    <CustomButton>
                        <Link to={pathes.CHOOSE_GROUP}>
                            <img src={icons.PLUS_WHITE}/>
                            گروه جدید
                        </Link>
                    </CustomButton>
                </NewGroupButton>
            </ContentLayout>
        </>
     );
}
 
export default MyGroups;

const Groups = styled.div`
    display: flex;
    flex-direction: column;
`
const GroupItem = styled.div`
    padding: 0 ${dimens.SPACING_XL};
`;

const Content = styled(Row)`
    align-items: center;
    gap: ${dimens.SPACING_XS};
    cursor: pointer;

    img {
        width: 3.75rem;
        aspect-ratio: 1;
        border-radius: ${dimens.BORDER_RADIUS_CIRCLE};
    }
`

const GroupInfo = styled(Col)`
    display: flex;
    flex-direction: column;
    gap: ${dimens.SPACING_XS};

    p {
        color: ${colors.text1};
        opacity: 0.6;
    }
`;

const NewGroupButton = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: ${dimens.SPACING_XL};

    img {
        width: 1rem;
    }
`;







